import React from 'react';
import { AiOutlineFileText } from 'react-icons/ai';
import { BiVideo } from 'react-icons/bi';
import {
  FaHashtag,
  FaCalendar,
  FaExternalLinkAlt,
  FaCreditCard,
  FaTrashAlt,
  FaDollarSign,
  FaExclamationCircle,
  FaInfoCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaUserCheck,
  FaUserAltSlash,
} from 'react-icons/fa';
import $ from 'jquery';
import store from '../../store';
import {
  GET_LEVEL_ONES,
  GET_LEVEL_TWOS,
  GET_LEVEL_THREES,
  GET_LEVEL_FOURS,
} from '../../store/Client/clientTypes';

import DOCX from '../images/docx.svg';
import PDF from '../images/pdf.svg';
import PHOTO from '../images/photo.svg';
import PPT from '../images/pptx.svg';
import XLSX from '../images/xlsx.svg';

import JCB from '../images/JCB.svg';
import AMEX from '../images/AMEX.svg';
import Visa from '../images/Visa.svg';
import Unknown from '../images/Unknown.svg';
import Discover from '../images/discover.svg';
import Diners from '../images/diners-club.svg';
import UnionPay from '../images/UnionPay.svg';
import MasterCard from '../images/Mastercard.svg';

import FAQ_1_1 from '../images/FAQs/FAQ_1_1.png';
import FAQ_1_2 from '../images/FAQs/FAQ_1_2.png';
import FAQ_1_3 from '../images/FAQs/FAQ_1_3.png';
import FAQ_2 from '../images/FAQs/FAQ_2.png';
import FAQ_3 from '../images/FAQs/FAQ_3.png';
import FAQ_4 from '../images/FAQs/FAQ_4.png';
import FAQ_5_1 from '../images/FAQs/FAQ_5_1.png';
import FAQ_5_2 from '../images/FAQs/FAQ_5_2.png';
import FAQ_5_3 from '../images/FAQs/FAQ_5_3.png';
import FAQ_6_1 from '../images/FAQs/FAQ_6_1.png';
import FAQ_6_2 from '../images/FAQs/FAQ_6_2.png';
import FAQ_6_3 from '../images/FAQs/FAQ_6_3.png';
import FAQ_7_1 from '../images/FAQs/FAQ_7_1.png';
import FAQ_7_2 from '../images/FAQs/FAQ_7_2.png';
import FAQ_8_1 from '../images/FAQs/FAQ_8_1.png';
import FAQ_8_2 from '../images/FAQs/FAQ_8_2.png';
import FAQ_9_1 from '../images/FAQs/FAQ_9_1.png';
import FAQ_9_2 from '../images/FAQs/FAQ_9_2.png';
import FAQ_9_3 from '../images/FAQs/FAQ_9_3.png';
import FAQ_10_1 from '../images/FAQs/FAQ_10_1.png';
import FAQ_10_2 from '../images/FAQs/FAQ_10_2.png';
import FAQ_10_3 from '../images/FAQs/FAQ_10_3.png';
import FAQ_10_4 from '../images/FAQs/FAQ_10_4.png';
import FAQ_11_1 from '../images/FAQs/FAQ_11_1.png';
import FAQ_11_2 from '../images/FAQs/FAQ_11_2.png';
import FAQ_11_3 from '../images/FAQs/FAQ_11_3.png';
import FAQ_11_4 from '../images/FAQs/FAQ_11_4.png';
import FAQ_11_5 from '../images/FAQs/FAQ_11_5.png';
import FAQ_12_1 from '../images/FAQs/FAQ_12_1.png';
import FAQ_12_2 from '../images/FAQs/FAQ_12_2.png';
import FAQ_12_3 from '../images/FAQs/FAQ_12_3.png';
import FAQ_12_4 from '../images/FAQs/FAQ_12_4.png';
import FAQ_13_1 from '../images/FAQs/FAQ_13_1.png';
import FAQ_13_2 from '../images/FAQs/FAQ_13_2.png';
import FAQ_13_3 from '../images/FAQs/FAQ_13_3.png';
import FAQ_14_1 from '../images/FAQs/FAQ_15_1.png';
import FAQ_14_2 from '../images/FAQs/FAQ_15_2.png';
import FAQ_15_1 from '../images/FAQs/FAQ_15_1.png';
import FAQ_15_2 from '../images/FAQs/FAQ_15_2.png';
import FAQ_15_3 from '../images/FAQs/FAQ_15_3.png';
import FAQ_15_4 from '../images/FAQs/FAQ_15_4.png';

import {
  API_LEVEL_ONE,
  API_LEVEL_TWO,
  API_LEVEL_THREE,
  API_LEVEL_FOUR,
} from '../../services/consts';
import { Store as NotificationStore } from 'react-notifications-component';
import { setCurrentPage } from '../../store/Document/documentActions';

/**
 * Get Download URL for files.
 * @param {string} fileName
 * @param {boolean} isPDF
 * @returns The assembled URL.
 */
export const DOWNLOAD_URL = (fileName, isPDF = false) =>
  `https://regulationcity.com/wp-content/uploads/2022/03/${
    isPDF ? 'PDF' : 'Word'
  }/${
    isPDF
      ? fileName.replace(/.docx/i, '.pdf').replace(/.doc/i, '.pdf')
      : fileName
  }`;

export const LEVELS = {
  ONE: {
    LIST: API_LEVEL_ONE,
    LABEL: 'Level One',
    ACTION: GET_LEVEL_ONES,
  },
  TWO: {
    LIST: API_LEVEL_TWO,
    LABEL: 'Level Two',
    ACTION: GET_LEVEL_TWOS,
  },
  THREE: {
    LIST: API_LEVEL_THREE,
    LABEL: 'Level Three',
    ACTION: GET_LEVEL_THREES,
  },
  FOUR: {
    LIST: API_LEVEL_FOUR,
    LABEL: 'Level Four',
    ACTION: GET_LEVEL_FOURS,
  },
};

/**
 * Adapt HTML content that was created for SharePoint site
 * @param {string} html The page HTML object
 * @param {string} pageId The page ID to be found and replaced in the text
 * @param {string} slug The page slug to be put in the place of the ID
 * @returns {string} The treated HTML for WordPress solution.
 */
export const preparePageHTML = (html, pageId, slug) => {
  return html
    .replace(/href="#/gi, 'href="/app')
    .replace(new RegExp(`${pageId}`, 'gi'), slug);
};

/**
 * Temporary solution while some DB stored data is still represented as ID and not Slug.
 * @param {string} docID The document ID to be transformed in slug.
 * @param {string} pageId The page ID to be transformed in slug.
 * @returns {{ docSlug: string, pageSlug: string}} The slug based on the ID provided
 */
export const getSlugFromIDs = (docID, pageId) => {
  try {
    let slugObj = {
      docSlug: docID,
      pageSlug: pageId,
    };
    if (docID) {
      const { documents } = store.getState().client;
      slugObj = {
        ...slugObj,
        docSlug:
          documents.filter((doc) => doc.id === docID)[0] &&
          documents.filter((doc) => doc.id === docID)[0].slug
            ? documents.filter((doc) => doc.id === docID)[0].slug
            : docID,
      };
    }
    if (pageId) {
      const { pages } = store.getState().client;
      slugObj = {
        ...slugObj,
        pageSlug:
          pages.filter((page) => page.id === pageId)[0] &&
          pages.filter((page) => page.id === pageId)[0].slug
            ? pages.filter((page) => page.id === pageId)[0].slug
            : pageId,
      };
    }
    return slugObj;
  } catch (e) {
    return {
      docSlug: docID,
      pageSlug: pageId,
    };
  }
};

/**
 * To validate email addresses.
 * Code reference: <https://stackoverflow.com/questions/46155/whats-the-best-way-to-validate-an-email-address-in-javascript>
 * @param {string} email The address to be validated
 * @returns If the email is valid or not.
 */
export const emailRegex = (email) =>
  email
    .toLowerCase()
    .match(
      new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    );

/**
 * To validate passwords.
 * Code reference: <https://stackoverflow.com/questions/12090077/javascript-regular-expression-password-validation-having-special-characters>
 * @param {string} password The password to be validated
 * @returns If the password is valid or not.
 */
export const passwordRegex = (password) =>
  password.match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&\(\)\[\]{},~;:|/\\<>_\-=+'"\.`])[A-Za-z\d@$#!%*?&\(\)\[\]{},~;:|/\\<>_\-=+'"\.`]{8,}$/g
    )
  );

export const REASONS = [
  'It’s too expensive',
  'I have another account on Regulation City',
  'I’m not using the product often enough',
  'It’s not meeting my requirements (Please specify)',
  'Other (Please specify)',
];

export const LOGIN_ERRORS = {
  NOT_FOUND: 'NOT_FOUND',
  WRONG_PASS: 'WRONG_PASS',
};

/**
 * Notify User.
 * @param {'danger' | 'warning' | 'info' | 'success'} type The type of notification.
 * @param {string} title The notification title.
 * @param {string | JSX.Element} message The notification message.
 * @param {number} width The notification width. (default is 350px for desktop and 280px for mobile)
 * @param {number} duration The notification duration in seconds. (default is 10s).
 */
export const notification = (
  type,
  title,
  message = '',
  width = window.innerWidth < 400 ? 280 : 350,
  duration = 10
) => {
  const icon = {
    danger: <FaTimesCircle className='notification-icon' />,
    warning: <FaExclamationCircle className='notification-icon' />,
    info: <FaInfoCircle className='notification-icon' />,
    success: <FaCheckCircle className='notification-icon' />,
  }[type];

  const titleContent = (
    <div className='d-flex align-items-center justify-content-start'>
      {icon}
      <span className='ml-2'>{title}</span>
    </div>
  );

  const messageContent = <React.Fragment>{message}</React.Fragment>;

  NotificationStore.addNotification({
    title: titleContent,
    message: messageContent,
    type: type,
    insert: 'top',
    container: 'top-right',
    animationIn: ['animate__animated', 'animate__fadeInRight'],
    animationOut: ['animate__animated', 'animate__fadeOutRight'],
    dismiss: {
      duration: duration * 1000,
      showIcon: true,
    },
    className: 'custom-notify',
    width: width,
  });
};

export const TokenExpiredNotification = () =>
  notification(
    'warning',
    'Your session has expired.',
    <span
      style={{
        fontWeight: 'bold',
        textDecoration: 'underline',
      }}
      onClick={() => window.location.reload()}
    >
      Click here to restart your session.
    </span>,
    350,
    30
  );

export const plans = [
  { text: '-Select-', value: '-Select-' },
  { text: 'Standard ($39 Monthly)', value: 'standard' },
  { text: 'Professional ($99 Monthly)', value: 'professional' },
  { text: 'Premium ($149 Monthly)', value: 'premium' },
  { text: 'Standard ($429 Yearly)', value: 'standard-yearly' },
  { text: 'Professional ($1089 Yearly)', value: 'professional-yearly' },
  { text: 'Premium ($1639 Yearly)', value: 'premium-yearly' },
];

/**
 *
 * @param {string} name
 * @returns The restriction level for the user according to their active plan.
 */
export const defineRestriction = (name) => {
  switch (name) {
    case 'Standard': {
      return 2;
    }
    case 'Professional': {
      return 1;
    }
    case 'Premium': {
      return 0;
    }
    default:
      return null;
  }
};

export const ACCOUNT_NAVIGATION = {
  INFO: {
    URL: 'info',
    NAV: 'Account Info',
    TITLE: 'Personal Information',
  },
  // PAYMENT: {
  //   URL: 'payment-settings',
  //   NAV: 'Payment Settings',
  //   TITLE: 'Payment Settings',
  // },
  MEMBERSHIP: {
    URL: 'membership-info',
    NAV: 'Membership Info',
    TITLE: 'Membership Info',
  },
  USAGE: {
    URL: 'usage',
    NAV: 'Usage',
    TITLE: 'My Usage Status',
  },
  // TRANSACTION: {
  //   URL: 'transaction-history',
  //   NAV: 'Transaction History',
  //   TITLE: 'Transaction History',
  // },
};

// account navigation for corporate plan admin
export const ADMIN_ACCOUNT_NAVIGATION = {
  INFO: {
    URL: 'info',
    NAV: 'Account Info',
    TITLE: 'Personal Information',
  },
  // PAYMENT: {
  //   URL: 'payment-settings',
  //   NAV: 'Payment Settings',
  //   TITLE: 'Payment Settings',
  // },
  MEMBERSHIP: {
    URL: 'membership-info',
    NAV: 'Membership Info',
    TITLE: 'Membership Info',
  },
  USAGE: {
    URL: 'usage',
    NAV: 'Usage',
    TITLE: 'My Usage Status',
  },
  // TRANSACTION: {
  //   URL: 'transaction-history',
  //   NAV: 'Transaction History',
  //   TITLE: 'Transaction History',
  // },
  // USERS: {
  //   URL: 'users',
  //   NAV: 'Users',
  //   TITLE: 'Users',
  // },
};

// account navigation for corporate plan basic user
export const BASIC_ACCOUNT_NAVIGATION = {
  INFO: {
    URL: 'info',
    NAV: 'Account Info',
    TITLE: 'Personal Information',
  },
};

// account navigation for super admin
export const SUPER_ADMIN_ACCOUNT_NAVIGATION = {
  INFO: {
    URL: 'info',
    NAV: 'Account Info',
    TITLE: 'Personal Information',
  },
  PRODUCTS: {
    URL: 'products',
    NAV: 'Products',
    TITLE: 'Products',
  },
  CLIENTS: {
    URL: 'clients',
    NAV: 'Clients',
    TITLE: 'Clients',
  },
};

/**
 *
 * @param {boolean} isDefault
 * @returns
 */
export const CardDDListOptions = [
  {
    text: 'Set As Default',
    value: 'default',
    icon: <FaCreditCard />,
  },
  // {
  //   text: 'Edit',
  //   value: 'edit',
  //   icon: <FaEdit />,
  // },
  {
    text: 'Remove',
    value: 'remove',
    icon: <FaTrashAlt />,
  },
];

// options for corporate accounts to handle users
export const UsersListOptions = [
  {
    text: 'Delete User',
    value: 'Remove',
    icon: <FaUserAltSlash />,
  },
  {
    text: 'Change Status to Admin',
    value: 'CorporateAdmin',
    icon: <FaUserCheck />,
  },
];

// options for corporate accounts to handle users
export const UsersListOptionsAdmin = [
  {
    text: 'Delete User',
    value: 'Remove',
    icon: <FaUserAltSlash />,
  },
  {
    text: 'Change Status to Viewer',
    value: 'CorporateBasic',
    icon: <FaUserCheck />,
  },
];

/**
 * Get card icon from string
 * @param {string} brand The card brand as string
 * @returns The brand icon.
 */
export const getCardIcon = (brand) => {
  brand = brand.toLowerCase();
  switch (brand) {
    case 'jcb':
      return JCB;
    case 'visa':
      return Visa;
    case 'amex':
      return AMEX;
    case 'discover':
      return Discover;
    case 'unionpay':
      return UnionPay;
    case 'diners_club':
      return Diners;
    case 'mastercard':
      return MasterCard;
    default:
      return Unknown;
  }
};

/**
 * @returns An object to be mapped in the UI.
 */
export const NUMBER_OF_USERS = [
  {
    text: '1 User',
    value: 1,
  },
  {
    text: '2 - 5 Users',
    value: 5,
  },
  {
    text: '6 - 10 Users',
    value: 10,
  },
  {
    text: '10+ Users? Contact Us',
    value: 20,
  },
];

// product id // production
// prod_LPzoR6BOrhFodV

/**
 * The list of available plans
 * @param {boolean} isAnnual Determine if user has selected monthly or annual.
 * @returns An object to be mapped in the UI.
 */
export const PLANS_LIST = (isAnnual = false) => ({
  USER: [
    {
      // id: isAnnual ? 'price_1KXx9HE7YofNAjifA6ckmYtk' : 'price_1KXx9HE7YofNAjifYjF6zIyx', // test
      id: isAnnual
        ? 'price_1Kj9sZE7YofNAjifuqo3YbBV'
        : 'price_1Kj9pHE7YofNAjifXzz6sdgr', // production
      title: 'Standard',
      price: isAnnual ? 468 : 39,
      itemsList: [
        'ASIC, APRA, AUSTRAC, RBA, ACCC, OAIC',
        'Automatic Glossary',
        'Automatic Links',
        'Automatic Classification on every page',
        'Advanced Search',
        'Instant Translation',
        'Mobile Optimised',
        'WCAG Accessible',
      ],
    },
    {
      // id: isAnnual ? 'price_1KXx9HE7YofNAjifnj8s0fCR' : 'price_1KXx9HE7YofNAjifoMcXY2V4', // test
      id: isAnnual
        ? 'price_1Kj9sZE7YofNAjifvBeGAlUT'
        : 'price_1Kj9sZE7YofNAjifY952TrLH', // production
      title: 'Professional',
      price: isAnnual ? 948 : 79,
      itemsList: [
        'Everything in Standard, plus',
        'Related Documents Automatically Linked',
        // 'Section to Section Relationships',
        'Related Content - Links, Videos, Images',
        'Output to Word or PDF',
        'Personalised Regulation List',
      ],
    },
    {
      // id: isAnnual ? 'price_1KXx9HE7YofNAjifHbMxAfCP' : 'price_1KXx9HE7YofNAjifatR4Zm1f', // test
      id: isAnnual
        ? 'price_1Kj9sZE7YofNAjifCYxubwEv'
        : 'price_1Kj9sZE7YofNAjifmCFmfem6', // production
      title: 'Premium',
      price: isAnnual ? 1788 : 149,
      itemsList: [
        'Everything in Professional, plus',
        'Email Alerts',
        'Previous Version Comparison',
      ],
    },
  ],
  ENTERPRISE: [
    {
      id: 'plan_enterprise',
      title: 'Enterprise',
      subTitle: 'For Teams',
      itemsList: [
        'For Teams (5+ People)',
        'User Management Console',
        'Custom Dashboard',
        'Custom Reports',
      ],
    },
  ],
});

/**
 * Calculate days between two dates
 * @param {Date} date1 Date from
 * @param {Date} date2 Date to
 * @returns {number} The amount of days between
 */
export const calculateTwoDates = (date1, date2) => {
  const oneDay = 24 * 60 * 60 * 1000;
  return Math.round(Math.abs((date1 - date2) / oneDay));
};

/**
 * Calculate days left on free trial
 * @param {string} startDate When the free trial started
 * @param {boolean} getEndDate When the free trial ends
 * @returns {number | Date} The amount of days left or the date itself
 */
export const calculateFreeTrial = (startDate, getEndDate = false) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const trialStarted = new Date(startDate);
  const now = new Date();

  const freeTrialDays = 30;

  const trialPeriodEnd = new Date(
    new Date(startDate).setDate(trialStarted.getDate() + freeTrialDays)
  );

  if (getEndDate) return trialPeriodEnd;

  // if trialPeriodEnd is larger than now means it has not expired, so calculate the days left
  return trialPeriodEnd > now
    ? freeTrialDays + Math.round((trialStarted - now) / oneDay)
    : -1;
};

/**
 * Defines the glossaries that are aplicable to the current page
 * @param {Array<object>} glossaries The global array of glossaries
 * @returns The array of applicable glossaries within the given page.
 */
export const defineApplicableGlossaries = (glossaries) => {
  try {
    const { currentDocument } = store.getState().document;
    const { spStructure } = store.getState().client;

    const applicableGlossaries = [];

    glossaries.forEach((glossary) => {
      if (glossary.Relationships && glossary.Relationships.length > 0) {
        glossary.Relationships.forEach((rel) => {
          if (rel.TargetType === 'Global')
            applicableGlossaries.push({
              ...glossary,
              displayLevel: 'Visible globally',
              hierarchy: 0,
            });
          else if (
            rel.TargetType === 'LevelOne' &&
            currentDocument.levelOne &&
            currentDocument.levelOne.ID === rel.TargetValue
          )
            applicableGlossaries.push({
              ...glossary,
              displayLevel: spStructure.LevelOne,
              hierarchy: 1,
            });
          else if (
            rel.TargetType === 'LevelTwo' &&
            currentDocument.levelTwo &&
            currentDocument.levelTwo.ID === rel.TargetValue
          )
            applicableGlossaries.push({
              ...glossary,
              displayLevel: spStructure.LevelTwo,
              hierarchy: 2,
            });
          // optional levels 3 and 4
          else if (
            spStructure.LevelThree &&
            rel.TargetType === 'LevelThree' &&
            currentDocument.levelThree &&
            currentDocument.levelThree.ID === rel.TargetValue
          )
            applicableGlossaries.push({
              ...glossary,
              displayLevel: spStructure.LevelThree,
              hierarchy: 3,
            });
          else if (
            spStructure.LevelFour &&
            rel.TargetType === 'LevelFour' &&
            currentDocument.levelFour &&
            currentDocument.levelFour.ID === rel.TargetValue
          )
            applicableGlossaries.push({
              ...glossary,
              displayLevel: spStructure.LevelFour,
              hierarchy: 4,
            });
          else if (
            rel.TargetType === 'Document' &&
            currentDocument.id === rel.TargetValue
          )
            applicableGlossaries.push({
              ...glossary,
              displayLevel: rel.TargetType,
              hierarchy: 5,
            });
        });
      }
    });
    return applicableGlossaries.sort((a, b) =>
      a.hierarchy < b.hierarchy ? 1 : -1
    );
  } catch (e) {
    console.log('issue on Glossary relationships', e);
    return [];
  }
};

export const RELATED_CONTENT_TYPES = {
  Image: <img src={PHOTO} alt='type-img' className='related-content-icon' />,
  Video: <BiVideo className='related-content-icon' />,
  'External Link': <FaExternalLinkAlt className='related-content-icon' />,
  Word: <img src={DOCX} alt='type-word' className='related-content-icon' />,
  PowerPoint: (
    <img src={PPT} alt='type-pptx' className='related-content-icon' />
  ),
  Excel: <img src={XLSX} alt='type-xlsx' className='related-content-icon' />,
  PDF: <img src={PDF} alt='type-pdf' className='related-content-icon' />,
};

export const HEADINGS = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
};

export const ROUTES = {
  HOME: '/app',
  LANDING: '/',
  BOOKMARKS: '/app/my-bookmarks',
  MY_ACCOUNT: '/app/my-account/',
  UPGRADE: '/app/my-account/update-subscription',
  ACCOUNT_INFO: '/app/my-account/info',
  LOGIN: '/app/account/login',
  SIGNUP: '/app/account/register',
  FORGOT: '/app/account/reset-password',
  FREE: '/app/account/register/free-trial',
  CORPORATE_LOGIN: '/app/account/login/corporate',
  MEMBERSHIP_INFO: '/app/my-account/membership-info',
  SELECT_PLANS: '/app/my-account/select-plans',
  USAGE: '/app/my-account/usage',
  QUERY: '/app/queries',
  // SEARCH: (param) => `/app/search/${param}`,
  SEARCH: `/app/search`,
  // PAYMENT: '/app/my-account/payment-settings',
  /**
   * @param {string} docSlug The Document slug
   * @param {string} pageSlug The Page slug
   * @param {string} scrollItem The scroll element, if user has clicked on a foot note or other internal document links
   * @returns The document page route
   */
  DOCUMENT: (docSlug, pageSlug, scrollItem) =>
    `/app/${docSlug}${pageSlug ? '/' + pageSlug : ''}${
      scrollItem ? '/' + scrollItem : ''
    }`,
  DOCUMENT_SEARCH: (docSlug, pageSlug, searchTerm) =>
    `/app/${docSlug}${pageSlug ? '/' + pageSlug : ''}${
      searchTerm ? '/search=' + searchTerm : ''
    }`,
};

export const COLORS = {
  DEFAULT: '#007C7C',
  DEFAULT_SECONDARY: '#FF8E37',
  DARK_GRAY: '#383838',
  LIGHT_GRAY: '#F1F1F1',
  LIGHT_GREEN: '#2F907C',
  WHITE: '#FFF',
  WARM_RED: '#F15F62',
  FRESH_ORANGE: '#E7901F',
  APPLE_GREEN: '#ACD149',
};
export const addCustomTags = (regularTags, textContent, document) => {
  const alltags =
    regularTags && regularTags.length > 0 ? [...regularTags.split(',')] : [];
  const customTags = [...document.customTags];

  customTags.forEach((customTag) => {
    customTag = clearString(customTag.trim());
    if (textContent.match(new RegExp(`(${customTag})`, 'i'))) {
      alltags.push('CUSTOMTAG' + customTag);
    }
  });

  return alltags.join();
};

/**
 * @param {string} text
 * @returns A cleansed string for RegEx searching.
 */
export const clearString = (text) => {
  text = text.replace(/\\/gi, '\\\\');
  text = text.replace(/\//gi, '\\/');

  text = text.replace(/\./gi, '\\.');
  text = text.replace(/\(/gi, '\\(');
  text = text.replace(/\)/gi, '\\)');
  text = text.replace(/\[/gi, '\\[');
  text = text.replace(/\]/gi, '\\]');

  text = text.replace(/\?/gi, '\\?');
  text = text.replace(/\{/gi, '\\{');
  text = text.replace(/\}/gi, '\\}');
  text = text.replace(/\*/gi, '\\*');
  text = text.replace(/\|/gi, '\\|');
  text = text.replace(/\+/gi, '\\+');
  text = text.replace(/\^/gi, '\\^');

  text = text.replace(/</gi, '');
  text = text.replace(/>/gi, '');
  return text;
};

export const loadText = (text) => {
  if (document.getElementById('extra-load-text')) {
    console.log('applying text', text);
    document.getElementById('extra-load-text').innerText = text;
  }
};

export const ClearTag = (customTag) => {
  return customTag.replace('CUSTOMTAG', '').trim();
};
export const DocSortColumns = (isDocSearch = false) => [
  {
    DISPLAY: 'Document Title',
    TOOLTIP: 'Title of a document with pages that match your search',
    VALUE: 'title',
    CSS: isDocSearch ? 'col-9' : 'col-6',
    ICON: <AiOutlineFileText />,
  },
  {
    DISPLAY: 'Results',
    TOOLTIP: 'Number of results inside the document',
    VALUE: 'results',
    CSS: isDocSearch ? 'd-none' : 'col-3',
    ICON: <FaHashtag />,
  },
  {
    DISPLAY: 'Version Date',
    TOOLTIP: 'Date of the regulation version.',
    VALUE: 'versionDate',
    CSS: 'col-3',
    ICON: <FaCalendar />,
  },
];

export const BookmarksColumns = (isSmall) => [
  {
    INPUT: true,
    DISPLAY: 'Section',
    TOOLTIP: 'Title of a section you have bookmarked.',
    VALUE: 'title',
    CSS: !isSmall ? 'col-4 pl-0 position-relative' : 'd-flex',
    ICON: <AiOutlineFileText />,
  },
  {
    DISPLAY: 'Document',
    TOOLTIP: 'Title of the document to which the section belongs to.',
    VALUE: 'documentName',
    CSS: !isSmall ? 'col-4' : 'd-flex',
    ICON: <AiOutlineFileText />,
  },
  {
    DISPLAY: 'Version Date',
    TOOLTIP: 'Date of the regulation version.',
    VALUE: 'versionDate',
    CSS: !isSmall ? 'col-2' : 'd-flex',
    ICON: <FaCalendar />,
  },
  {
    DISPLAY: 'Regulator',
    TOOLTIP: 'Title of the regulator to which the document belongs to',
    VALUE: 'levelOne',
    CSS: !isSmall ? 'col-2' : 'd-flex',
    ICON: <AiOutlineFileText />,
    FILTER: true,
  },
];

export const TransactionsColumns = [
  {
    DISPLAY: 'Date',
    FLEX: 3,
    SORT: true,
    TOOLTIP: 'The date in which the transaction occurred.',
    ICON: <FaCalendar />,
  },
  {
    DISPLAY: 'Invoice No.',
    FLEX: 4,
    TOOLTIP: 'The Invoice Number.',
    ICON: <FaHashtag />,
  },
  {
    DISPLAY: 'Amount',
    TOOLTIP: 'The amount of the transaction.',
    FLEX: 3,
    ICON: <FaDollarSign />,
  },
  {
    DISPLAY: 'Status',
    TOOLTIP: 'Status of the transaction.',
    FLEX: 3,
    ICON: <AiOutlineFileText />,
    FILTER: true,
  },
];

// columns on tab user for corporate admin
export const UserColumns = [
  {
    // INPUT: true,
    DISPLAY: 'Name',
    VALUE: 'name',
    CSS: 'col-4 p-0 position-relative',
  },
  {
    DISPLAY: 'Email',
    VALUE: 'email',
    CSS: 'col-6',
  },
  {
    DISPLAY: 'Role',
    VALUE: 'role',
    CSS: 'col-2 pl-2 justify-content-start',
  },
];

/**
 * Returns the unique values in a list of objects or any other type.
 * @param {Array} list The array to be filtered.
 * @param {any} obj The object to extract unique values. Send null if array is any type other than object.
 * @param {boolean} DDList Specifies if the list needs to be in DDList format
 * @param {string} ChildKey The child key to be extracted instead.
 * @returns A list of unique strings or objects
 */
export const ListUniqueValues = (
  list = [],
  obj = '',
  DDList = false,
  ChildKey
) => {
  const keysList =
    obj === null || obj.length < 1
      ? list
      : ChildKey
      ? list.map((item) => item[obj]).map((child) => child[ChildKey])
      : list.map((item) => item[obj]);

  const uniqueKeys =
    keysList.length > 1
      ? keysList.filter((value, index) => keysList.indexOf(value) === index) // remove duplicates
      : keysList; // if it only has one type, it will remove from array

  return DDList
    ? uniqueKeys.map((item) => ({ text: item, value: item }))
    : uniqueKeys;
};

export const toggleFadeMainContent = (current) => {
  const main = document.getElementById('main-content');

  if (!current) {
    main.style.backgroundColor = COLORS.DARK_GRAY;
    main.style.opacity = '0.15';
  } else {
    main.style.backgroundColor = COLORS.WHITE;
    main.style.opacity = '1';
  }
};

export const highlightElement = (element) => {
  // console.log('highlighting element', element);
  element.style.backgroundColor = '#ffff0070';
  element.style.transition = '2s';

  setTimeout(() => {
    element.style.backgroundColor = 'transparent';
  }, element.offsetTop + 3000);
};

export const scrollToElement = (elementID, counter = 1) => {
  const HTMLElement = document.getElementById(elementID);
  // if React layer detects it should scroll but DOM has not yet rendered element
  if (!HTMLElement) {
    // using set timeout will give the DOM enough time to load
    setTimeout(() => {
      if (counter < 5) {
        // added counter to prevent infinite loop if url is not pointing to an actual element
        // 5 attempts should be enough to stop it from being called
        scrollToElement(elementID, (counter += 1));
      }
    }, 100);
  } else {
    // if we're on mobile
    if (
      window.innerWidth < 768 ||
      (window.innerWidth < 950 && window.innerHeight < 415)
    ) {
      $('#main-content').scrollTop(
        HTMLElement.offsetTop -
          16 +
          document.getElementById('sticky-top-wrapper').clientHeight
      );
    } else {
      // need to differenciate due to header position
      $('#main-content').scrollTop(HTMLElement.offsetTop);
    }

    highlightElement(HTMLElement);
  }
};

export const addScrollEvent = () => {
  const page = store.getState().document.currentPage;

  if (page && page.HTMLContent) {
    // to find links to the same page
    const samePageLinkRegEx = new RegExp(
      `href="/app/${page.documentId}/${page.id}/(.*?)"`,
      'g'
    );
    page.HTMLContent.match(samePageLinkRegEx) &&
      page.HTMLContent.match(samePageLinkRegEx).forEach((match) => {
        // the id of the element after the page id
        const targetID = match
          .replace(`href="/app/${page.documentId}/${page.id}/`, '')
          .replace(`"`, '');

        if (document.getElementById(`#${targetID}`)) {
          // if it is on the same page, remove target blank
          // document.getElementById(`#${targetID}`).removeAttribute('target');
          // fixed the url from conversion during Document Preview

          const trigger = document.getElementById(`#${targetID}`);

          trigger.addEventListener('click', (e) => {
            scrollToElement(targetID);
            e.preventDefault();
          });
        }
      });
  }
};

export const addScrollEvent1 = () => {
  const page = store.getState().document.currentPage;

  if (page && page.HTMLContent) {
    // to find links to the same page
    const sameDocLinkRegEx = new RegExp(
      `href="/app/${page.documentId}(.*?)"`,
      'g'
    );
    page.HTMLContent.match(sameDocLinkRegEx) &&
      page.HTMLContent.match(sameDocLinkRegEx).forEach((match) => {
        // the id of the element after the page id

        const pageID = match
          .replace(`href="/app/${page.documentId}/`, '')
          .replace(`"`, '')
          .split('/')[0];

        const targetID = match
          .replace(`href="/app/${page.documentId}/`, '')
          .replace(`"`, '')
          .split('/')[1];

        if (document.getElementById(`#${targetID}`)) {
          // if it is on the same page, remove target blank
          // document.getElementById(`#${targetID}`).removeAttribute('target');
          // fixed the url from conversion during Document Preview

          const trigger = document.getElementById(`#${targetID}`);

          if (pageID !== page.id)
            console.log('found link to different page', pageID);

          trigger.onclick = (e) => {
            console.log('clicked', pageID);
            // links in another page of same document
            if (pageID !== page.id) {
              setCurrentPage(page);
            } else {
              scrollToElement(targetID);
            }
            e.preventDefault();
          };
        }
      });
  }
};

export const clickElement = (elementID) => {
  document.getElementById(elementID).click();
};

export const displayDocVersion = (doc) => {
  const { title, version } = doc;
  let display = title;

  if (version) {
    const versionHTML = `<div>${title} &#8226; v ${version}</div>`;

    const div = document.createElement('div');
    div.innerHTML = versionHTML;

    display = div.textContent;
  }

  return display;
};

export const setElementHeights = (page = 'document') => {
  if (
    document.getElementById('wf-scroll-wrapper') &&
    document.getElementById('sticky-top-wrapper') &&
    document.getElementsByClassName('footer')[0]
  ) {
    const main = document.getElementById('main-content');
    const doc = document.getElementById('wf-document');
    const bookmarks = document.getElementById('wf-bookmarks');
    const myAccount = document.getElementById('wf-my-account');

    if (window.innerHeight > 720) {
      const mainHeight =
        document.getElementById('wf-scroll-wrapper').clientHeight -
        document.getElementById('sticky-top-wrapper').clientHeight -
        document.getElementsByClassName('footer')[0].clientHeight;

      if (main) main.style.height = mainHeight + 'px';
      if (doc) doc.style.height = mainHeight + 'px';
      if (bookmarks) bookmarks.style.height = mainHeight + 'px';
      if (myAccount) myAccount.style.height = mainHeight + 'px';
    }
    // on small height viewports, we want to take as much space as we need
    // and allow users to scroll the whole screen freely
    else {
      const mainHeight = '100%';

      if (main) main.style.height = mainHeight;
      if (doc) doc.style.height = mainHeight;
      if (bookmarks) bookmarks.style.height = mainHeight;
      if (myAccount) myAccount.style.height = mainHeight;
    }
  }
};

export const pageHasContent = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  if (html.match('img')) return true;
  else return div.textContent.trim().length !== 0;
};

export const firstPageWithContent = (pages = []) => {
  if (pages && pages.length > 0) {
    // if a the first page of a document is empty, loop until finding a populated page
    let pageNotSet = true;
    let firstPage;

    pages.forEach((page) => {
      if (pageHasContent(page.HTMLContent) && pageNotSet === true) {
        pageNotSet = false;
        firstPage = page;
      }
    });

    // if it doesnt find any, display the first one
    if (pageNotSet === true) firstPage = pages[0];

    return firstPage;
  } else return null;
};

export const footerText = () => {
  const currentDocument = store.getState().document.currentDocument;
  if (currentDocument && currentDocument.levelOne) {
    const levelOne = currentDocument.levelOne.Title.toUpperCase();

    const sourced = `Based on content from the Federal Register of Legislation at 01/09/2024. For the latest information on Australian Government legislation please go to `;

    const legislation = (
      <a href='https://www.legislation.gov.au' target='_blank' rel='noreferrer'>
        https://www.legislation.gov.au.
      </a>
    );

    return (
      <React.Fragment>
        {{
          ASIC: 'Ⓒ Australian Securities & Investments Commission. Reproduced with permission.',
          APRA: 'Ⓒ Commonwealth of Australia.',
          ACCC: 'ACCC Ⓒ Commonwealth of Australia.',
          AUSTRAC: 'Ⓒ AUSTRAC for the Commonwealth of Australia.',
          OAIC: 'Office of the Australian Information Commissioner website — www.oaic.gov.au.',
          RBA: 'Source: Reserve Bank of Australia.',
        }[levelOne] || null}
        <br />
        {sourced}
        {legislation}
      </React.Fragment>
    );
  }
};

/**
 * Css Gambiarra to prevent APRA from being translated to "OPEN", among other translation issues
 * @param {string} text The string to be evaluated
 * @returns If the element should have the "notranslate" class or not
 */
export const TranslateWorkaround = (text) => {
  return text && text.toUpperCase() !== 'OTHER REGULATIONS'
    ? ' notranslate'
    : '';
};

const setImage = (id) => {
  document
    .getElementById('selectedImage')
    .setAttribute('src', document.getElementById(id).getAttribute('src'));
  $('#FAQModal').modal('hide');
  $('#imageModal').modal('show');
  $('.modal-backdrop').appendTo('#wf-doc-page');
};

export const FAQs = [
  {
    isAccount: false,
    NUMBER: 1,
    TITLE: 'How do I find the document I need?',
    CONTENT: (
      <div className='question-body'>
        <p>
          Click on a tile on the home page. This will open a modal showing all
          the documents for the regulator you have selected.
        </p>
        <img
          alt='FAQ'
          id='FAQ_1_1'
          className='clickable'
          onClick={() => setImage('FAQ_1_1')}
          src={FAQ_1_1}
        />
        <img
          alt='FAQ'
          id='FAQ_1_2'
          className='clickable'
          onClick={() => setImage('FAQ_1_2')}
          src={FAQ_1_2}
        />
        <p>
          Click on the document name – and the document will open as a series of
          web pages
        </p>
        <img
          alt='FAQ'
          id='FAQ_1_3'
          className='clickable'
          onClick={() => setImage('FAQ_1_3')}
          src={FAQ_1_3}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 2,
    TITLE: 'How do I return to the home page?',
    CONTENT: (
      <div className='question-body'>
        <p>
          To return to the home page, click either on Back in the top navigation
          or on the RegulationCity logo.
        </p>
        <img
          alt='FAQ'
          id='FAQ_2'
          className='clickable'
          onClick={() => setImage('FAQ_2')}
          src={FAQ_2}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 3,
    TITLE: 'How do I navigate to a section within a document?',
    CONTENT: (
      <div className='question-body'>
        <p>
          The left-hand navigation is built from the table of the contents of
          the document. The main headings are accessed directly from the
          navigation. Sub headings drop down as soon as the down arrow on the
          section is selected.
        </p>
        <img
          alt='FAQ'
          id='FAQ_3'
          className='clickable'
          onClick={() => setImage('FAQ_3')}
          src={FAQ_3}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 4,
    TITLE: 'How do I close one section and move to another?',
    CONTENT: (
      <div className='question-body'>
        <p>
          To close the drop-down headings, click on the down arrow again and the
          sub-headings close.
        </p>
        <img
          alt='FAQ'
          id='FAQ_4'
          className='clickable'
          onClick={() => setImage('FAQ_4')}
          src={FAQ_4}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 5,
    TITLE: 'How do I move from one document to another?',
    CONTENT: (
      <div className='question-body'>
        <h3 className='wf-h2'>
          <b>Option 1</b>
        </h3>
        <p>
          Click on Back in the top navigation. This will return you to the Home
          Page from where all documents can be accessed.
        </p>
        <img
          alt='FAQ'
          id='FAQ_5_1'
          className='clickable'
          onClick={() => setImage('FAQ_5_1')}
          src={FAQ_5_1}
        />
        <p>
          The home page will appear. Select the Regulator and the document you
          need.
        </p>
        <img
          alt='FAQ'
          id='FAQ_5_2'
          className='clickable'
          onClick={() => setImage('FAQ_5_2')}
          src={FAQ_5_2}
        />
        <h3 className='wf-h2'>
          <b>Option 2</b>
        </h3>
        <p>
          Select the regulator from the top navigation. This will display a
          modal of all the documents in RegulationCity for that regulator. Find
          the document you need and click on the title
        </p>
        <img
          alt='FAQ'
          id='FAQ_5_3'
          className='clickable'
          onClick={() => setImage('FAQ_5_3')}
          src={FAQ_5_3}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 6,
    TITLE: 'How do I use the Classification Tags?',
    CONTENT: (
      <div className='question-body'>
        <p>
          The tags display the key terms on every page, and are generated based
          upon frequency. Clicking on a tag will open up a page that show all
          the places within RegulationCity where this term appears. Tags enable
          you to easily conduct a filtered search on the site.
        </p>
        <img
          alt='FAQ'
          id='FAQ_6_1'
          className='clickable'
          onClick={() => setImage('FAQ_6_1')}
          src={FAQ_6_1}
        />
        <b className='mt-4'>
          <em>Note The tag to be clicked on is Identification procedures.</em>
        </b>
        <p>
          The selection of the tag{' '}
          <b>
            <em>identification procedures</em>
          </b>{' '}
          shows the frequency of this term in the regulations in RegulationCity.
        </p>
        <img
          alt='FAQ'
          id='FAQ_6_2'
          className='clickable'
          onClick={() => setImage('FAQ_6_2')}
          src={FAQ_6_2}
        />
        <p>The search result shows where this term appears in the documents</p>
        <img
          alt='FAQ'
          id='FAQ_6_3'
          className='clickable'
          onClick={() => setImage('FAQ_6_3')}
          src={FAQ_6_3}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 7,
    TITLE: 'How do I return to the page view?',
    CONTENT: (
      <div className='question-body'>
        <p>
          When selecting a tag and generating the list of pages where that tag
          appears, the navigation on the left-hand side is static. To return to
          your document, simply click on the close button at the top.
        </p>
        <img
          alt='FAQ'
          id='FAQ_7_1'
          className='clickable'
          onClick={() => setImage('FAQ_7_1')}
          src={FAQ_7_1}
        />
        <img
          alt='FAQ'
          id='FAQ_7_2'
          className='clickable'
          onClick={() => setImage('FAQ_7_2')}
          src={FAQ_7_2}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 8,
    TITLE: 'How do I download a PDF or Word version of a regulation?',
    CONTENT: (
      <div className='question-body'>
        <p>
          If you wish to download a PDF or Word version of the regulation you
          are viewing, select Download from the right-hand navigation.
        </p>
        <img
          alt='FAQ'
          id='FAQ_8_1'
          className='clickable'
          onClick={() => setImage('FAQ_8_1')}
          src={FAQ_8_1}
        />
        <p>
          In the Download option, select either PDF version or Word Version.
        </p>
        <img
          alt='FAQ'
          id='FAQ_8_2'
          className='clickable'
          onClick={() => setImage('FAQ_8_2')}
          src={FAQ_8_2}
        />
        <p>
          This action will automatically save a PDF or Word file to your
          downloads folder.
        </p>
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 9,
    TITLE: 'How do I use the Glossary?',
    CONTENT: (
      <div className='question-body'>
        <p>
          The Glossary generates a pop up definition of terms when you run your
          mouse over a term appearing in{' '}
          <b style={{ color: '#123466' }}>Blue</b> in the text.
        </p>
        <img
          alt='FAQ'
          id='FAQ_9_1'
          className='clickable'
          onClick={() => setImage('FAQ_9_1')}
          src={FAQ_9_1}
        />
        <p>The Glossary is also accessible from the right-hand navigation.</p>
        <p>Click on a glossary and a list of terms will be displayed.</p>
        <img
          alt='FAQ'
          id='FAQ_9_2'
          className='clickable'
          onClick={() => setImage('FAQ_9_2')}
          src={FAQ_9_2}
        />
        <img
          alt='FAQ'
          id='FAQ_9_3'
          className='clickable'
          onClick={() => setImage('FAQ_9_3')}
          src={FAQ_9_3}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 10,
    TITLE: 'How do I translate the Content?',
    CONTENT: (
      <div className='question-body'>
        <p>
          RegulationCity includes a translate function – enabling translation of
          any document into any one of 100 languages with a single click.
        </p>
        <p>
          To use the translation function, simply select the language. 10 flags
          are displayed and all other languages are accessible from a drop down
          list.
        </p>
        <img
          alt='FAQ'
          id='FAQ_10_1'
          className='clickable'
          onClick={() => setImage('FAQ_10_1')}
          src={FAQ_10_1}
        />
        <p>
          If the language you need is not in the flag display, click on Select
          Language to display all other language option.
        </p>
        <img
          alt='FAQ'
          id='FAQ_10_2'
          className='clickable'
          onClick={() => setImage('FAQ_10_2')}
          src={FAQ_10_2}
        />
        <p>
          Selecting Hindi for example will display all the content in this
          language
        </p>
        <img
          alt='FAQ'
          id='FAQ_10_3'
          className='clickable'
          onClick={() => setImage('FAQ_10_3')}
          src={FAQ_10_3}
        />
        <p>
          To return to English, simply select the Australian flag from the flag
          list or click on the 'Refresh Content' button.
        </p>
        <img
          alt='FAQ'
          id='FAQ_10_4'
          className='clickable'
          onClick={() => setImage('FAQ_10_4')}
          src={FAQ_10_4}
        />
      </div>
    ),
  },
  {
    isAccount: false,
    NUMBER: 11,
    TITLE: 'How do I use the Accessibility Feature?',
    CONTENT: (
      <div className='question-body'>
        <p>
          RegulationCity includes an Accessibility function – for any user who
          has sight impairment. Click on the accessibility icon in the bottom
          right of the page
        </p>
        <img
          alt='FAQ'
          id='FAQ_11_1'
          className='clickable'
          onClick={() => setImage('FAQ_11_1')}
          src={FAQ_11_1}
        />
        <p>The menu of accessibility options will be displayed.</p>
        <img
          alt='FAQ'
          id='FAQ_11_2'
          className='clickable'
          onClick={() => setImage('FAQ_11_2')}
          src={FAQ_11_2}
        />
        <p>For colour blindness, select reverse contrast.</p>
        <img
          alt='FAQ'
          id='FAQ_11_3'
          className='clickable'
          onClick={() => setImage('FAQ_11_3')}
          src={FAQ_11_3}
        />
        <p>For larger font. Select increase font.</p>
        <img
          alt='FAQ'
          id='FAQ_11_4'
          className='clickable'
          onClick={() => setImage('FAQ_11_4')}
          src={FAQ_11_4}
        />
        <p>To return to the original display, select Reset.</p>
        <img
          alt='FAQ'
          id='FAQ_11_5'
          className='clickable'
          onClick={() => setImage('FAQ_11_5')}
          src={FAQ_11_5}
        />
      </div>
    ),
  },
  {
    isAccount: true,
  },
];

export const AccountList = [
  {
    isAccount: true,
    NUMBER: 12,
    TITLE: 'How do I increase or decrease the level of my subscription?',
    CONTENT: (
      <div className='question-body'>
        <p>1. Got to My Account / Account Settings</p>
        <img
          alt='FAQ'
          id='FAQ_12_1'
          className='clickable'
          onClick={() => setImage('FAQ_12_1')}
          src={FAQ_12_1}
        />
        <p>2. Select Membership Info</p>
        <img
          alt='FAQ'
          id='FAQ_12_2'
          className='clickable'
          onClick={() => setImage('FAQ_12_2')}
          src={FAQ_12_2}
        />
        <p>
          3. Select <b>Update Subscription.</b> This action will display all the
          different plans available
        </p>
        <img
          alt='FAQ'
          id='FAQ_12_3'
          className='clickable'
          onClick={() => setImage('FAQ_12_3')}
          src={FAQ_12_3}
        />
        <p>4. Select the desired plan and complete the payment</p>
        <img
          alt='FAQ'
          id='FAQ_12_4'
          className='clickable'
          onClick={() => setImage('FAQ_12_4')}
          src={FAQ_12_4}
        />
      </div>
    ),
  },
  {
    isAccount: true,
    NUMBER: 13,
    TITLE: 'How do I cancel my subscription?',
    CONTENT: (
      <div className='question-body'>
        <p>1. Go to My Account and then click on Account Settings.</p>
        <img
          alt='FAQ'
          id='FAQ_13_1'
          className='clickable'
          onClick={() => setImage('FAQ_13_1')}
          src={FAQ_13_1}
        />
        <p>2. Click on Membership Info</p>
        <img
          alt='FAQ'
          id='FAQ_13_2'
          className='clickable'
          onClick={() => setImage('FAQ_13_2')}
          src={FAQ_13_2}
        />
        <p>3. Click on Cancel Subscription.</p>
        <p>
          4. You will have the option to retain your subscription at this point
        </p>
        <img
          alt='FAQ'
          id='FAQ_13_3'
          className='clickable'
          onClick={() => setImage('FAQ_13_3')}
          src={FAQ_13_3}
        />
      </div>
    ),
  },
  {
    isAccount: true,
    NUMBER: 14,
    TITLE: 'How do I update my payment method?',
    CONTENT: (
      <div className='question-body'>
        <p>1. Go to My Account and then click on Account Settings.</p>
        <img
          alt='FAQ'
          id='FAQ_14_1'
          className='clickable'
          onClick={() => setImage('FAQ_14_1')}
          src={FAQ_14_1}
        />
        <p>2. Click on Membership Info</p>
        <img
          alt='FAQ'
          id='FAQ_14_2'
          className='clickable'
          onClick={() => setImage('FAQ_14_2')}
          src={FAQ_14_2}
        />
        <p>3. Click on Update Payment Method and enter the new card details.</p>
      </div>
    ),
  },
  {
    isAccount: true,
    NUMBER: 15,
    TITLE: 'How do I buy additional AI Queries?',
    CONTENT: (
      <div className='question-body'>
        <p>1. Go to My Account and then click on Account Settings.</p>
        <img
          alt='FAQ'
          id='FAQ_15_1'
          className='clickable'
          onClick={() => setImage('FAQ_15_1')}
          src={FAQ_15_1}
        />
        <p>2. Click on Usage</p>
        <img
          alt='FAQ'
          id='FAQ_15_2'
          className='clickable'
          onClick={() => setImage('FAQ_15_2')}
          src={FAQ_15_2}
        />
        <p>3. Click on Buy more AI Queries.</p>
        <img
          alt='FAQ'
          id='FAQ_15_3'
          className='clickable'
          onClick={() => setImage('FAQ_15_3')}
          src={FAQ_15_3}
        />
        <p>
          4. Select the desired number of AI Queries from the dropdown and click
          on Complete Purchase
        </p>
        <img
          alt='FAQ'
          id='FAQ_15_4'
          className='clickable'
          onClick={() => setImage('FAQ_15_4')}
          src={FAQ_15_4}
        />
      </div>
    ),
  },
];

export const formatDate = (date) => {
  return new Date(date)
    .toLocaleTimeString([], {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
    .split('at')[0]
    .trim();
};

export const USER = {
  USAGE: {
    PAGEVIEWS: 'pageviews',
    QUERIES: 'queries',
    SUMMARIES: 'summaries',
    SHARES: 'shares',
    ADDITIONALQUERIES: 'additionalqueries',
  },
};

export const mockGlossary = `"accommodation bond":"A lump sum payment for accommodation in a residential care facility paid by a person who first entered permanent residential care before 1 July 2014.","Accommodation Payment Guarantee Scheme":"An Australian Government scheme providing a guarantee to all residential aged care consumers that the value of any lump sum accommodation payments they have paid to an aged care provider will be returned to them, in the event that the provider becomes insolvent.","Accommodation Supplement":"A means tested supplement paid to residential aged care providers by the Australian Government on behalf of some residents to assist with some   or all of their accommodation costs.","activities of daily living":"A core set of self-care or personal care activities that include bathing and washing, dressing, feeding, getting in and out of bed, getting to and from the toilet and continence management.","activities of daily living domain":"A domain under the Aged Care Funding Instrument which assesses  a person\u2019s capacity in relation to nutrition, mobility, personal hygiene, toileting and continence.","Aged Care Approvals Round":"An application process which enables aged care providers to apply for a limited number of Australian Government-subsidised places and/or capital grants.","Aged Care Assessment Team":"A team of medical and allied health professionals employed by State and Territory Governments who assess older people for eligibility and level of subsidised aged care services. In Victoria, it is known as the Aged Care Assessment Service.","Aged Care Diversity Framework":"An Australian Government strategy aimed at ensuring aged care services meet the needs of people from diverse backgrounds.","Aged Care Financial Report":"An annual financial report that all approved providers must provide to the Australian Government.","Aged Care Financing Authority":"A Committee, established under the Aged Care Act 1997 (Cth), to provide independent advice to the Australian Government on aged care funding   and financing in consultation with people in aged care, the aged care sector and the finance sectors.","Aged Care Funding Instrument":"A tool used to determine the basic subsidy amount a residential aged care provider receives in relation to a resident in its care.","Aged Care Pricing Commissioner":"An independent statutory office holder who reviews and approves Refundable Accommodation Deposits in residential aged care that are more than $550,000 and extra service fee increases or decreases.","Aged Care Principles":"A series of legislative instruments made under the Aged Care Act 1997 (Cth) that set out the rules for government-funded aged care.","Aged Care Quality and Safety Commission":"A Commonwealth entity established by the Aged Care Quality and Safety Commission Act 2018 (Cth) to assist the Aged Care Quality and Safety Commissioner in the performance of the Commissioner\u2019s functions.","Aged Care Quality and Safety Commissioner":"A person appointed under the Aged Care Quality and Safety Commission Act 2018 (Cth) to regulate and promote quality and safety in the aged care system.","Aged Care Quality Standards":"A set of standards for the provision of aged care that apply to all Australian Government subsidised aged care services. The standards are set out in Schedule 2 to the Quality of Care Principles 2014 (Cth).","Aged Care Target Provision Ratio":"A target set by the Australian Government for the number of home care, residential care, and restorative care places for every 1000 people aged 70 years or over.","Annual Prudential Compliance Statement":"An annual report residential aged care providers must submit to the Australian Government if they held a Refundable Accommodation Deposit, accommodation bond, or entry contribution during the reporting period.","approved provider":"An organisation approved under Part 7A of the Aged Care Quality and Safety Commission Act 2018 (Cth) to receive subsidies from the Australian Government for providing home care, residential aged care or flexible care services, or a combination of these.","assistive technology":"Devices and technologies that maintain or improve an older person\u2019s functioning to facilitate safety, independence, social inclusion and enhance overall wellbeing","Australian Affordable Housing Bond Aggregator":"Loans provided by the National Housing Finance and Investment Corporation to registered community housing providers that are low cost, long-term loans to support the provision of more social and affordable housing.","Australian Commission on Safety and Quality in Health Care":"A Commonwealth entity established by the National Health Reform Act 2011\r\n(Cth) to promote the quality and safety of the health care system.","Australian National Aged Care Classification (AN-ACC)":"A proposed new assessment and funding model for residential aged care developed by the Australian Health Services Research Institute (AHSRI).","Basic Daily Fee":"The fee people receiving a Home Care Package or residential aged care may pay for day-to-day services","behaviour domain":"A domain under the Aged Care Funding Instrument which assesses a person\u2019s cognitive skills, \u2018wandering\u2019, verbal behaviour, physical behaviour and level of depression.","care finders":"A proposed workforce of personal advisers to older people, their families and carers that work face-to-face","care leaver":"An adult who spent time in institutional or out-of-home care as a child, including the Forgotten Australians and former child migrants","care management":"The day-to-day coordination of care","Carer Gateway":"A service funded by the Australian Department of Social Services which helps carers access practical information and advice and connect with services in their local area.","carer leave":"Leave provided for in the National Employment Standards to allow employees to provide care or support to a member of the employee\u2019s immediate family, or a member of the employee\u2019s household.","carers hub":"Community-based hubs providing information and support for informal carers which can help reduce stress and feelings of isolation.","centre-based respite":"Daytime respite delivered in a group-based setting, such as a community centre or residential aged care home.","changed behaviour":"Changes in a person\u2019s behaviour that are caused by dementia. In medical literature this is sometimes referred to as \u2018behavioural and psychological symptoms of dementia\u2019 or BPSD.","Commonwealth Continuity of Support Programme":"A government support service for people with disability who do not qualify  for the National Disability Insurance Scheme and are an existing client of state-managed specialist disability services at the time the programme commenced in their region.","Commonwealth Home Support Programme":"An entry-level program that is intended to provide ongoing or short-term care and support services to older people such as help with housework, personal care, meals, shopping, allied health, social support and planned respite.","Community controlled health service":"An incorporated organisation initiated by and based in a local Aboriginal community, governed by an Aboriginal body which is elected by the local Aboriginal community, and that delivers holistic and culturally appropriate health care.","Community Visitors Scheme":"Australian Government scheme that arranges visits by volunteers to older people who use aged care services.","Community Visitors Scheme auspices":"Organisations that receive funding from the Community Visitor Scheme to recruit, train and support volunteers, conduct police checks, match volunteers to older people receiving care, and support relationships between volunteers and the people they visit.","complex health care domain":"A domain under the Aged Care Funding Instrument which assesses a person\u2019s need for ongoing complex health procedures and activities.","compulsory reporting scheme":"A scheme under the Aged Care Act 1997 (Cth) requiring approved providers of residential aged care to report alleged or suspected assaults and circumstances when a resident is absent without explanation.","cottage respite":"Usually overnight respite delivered in a cottage-style or home-like setting.","Daily Accommodation Contribution":"A method of payment for residential aged care accommodation that accrues daily and is paid by periodic payment","Daily Accommodation Payment":"A method of payment for residential aged care accommodation that accrues daily and is paid by periodic payment","Disability Support for Older Australians Program":"An Australian Government program to replace the Commonwealth Continuity of Support Programme, due to commence on 1 July 2021.","flexible care services":"Flexible care services include care provided through the Multi-Purpose Services Program, Transition Care Program, Short-Term Restorative Care Program and the National Aboriginal and Torres Strait Islander Flexible Aged Care Program.","fully supported residents":"Residents of aged care facilities whose income and assets are assessed as falling below the means testing threshold so they do not have to contribute to their accommodation or care costs.","Home and Community Care Program":"Former program for aged care home support administered by State and Territory Governments. Replaced by the Commonwealth Home Support Programme from 2012.","home care":"Care consisting of a package of personal care services and other personal assistance provided to a person who is not being provided with residential care.","Home Care Packages Program":"An Australian Government program that provides people with in-home aged care services by assigning funding directly to people receiving care (rather than to care providers","homeless supplement":"An Australian Government payment for aged care providers who specialise in caring for people who are experiencing homelessness, or are at risk of homelessness, at the time they entered permanent residential care","Independent Hospital Pricing Authority":"An agency established under the National Health Reform Act 2011 (Cth) to determine the \u2018national efficient price\u2019 for health care services provided by public hospitals.","informal carer":"A family member or friend of an older person who provides regular, ongoing assistance with everyday personal activities.","Integrated Carer Support Service":"Ongoing Australian Department of Social Services program commenced 1 July 2015 aiming to consolidate a wide range of carer support services","interim Home Care Package":"A Home Care Package of a lower level than the one approved to be received.","Maximum Permissible Interest Rate":"An Australian Government-set maximum interest rate a residential aged care provider can use to calculate daily accommodation rates based on agreed room price.","Multi-Purpose Services Program":"A program combining funding for aged care services from the Australian Government and State and Territory health services, to support small regional and remote communities to offer flexible aged care services.","My Aged Care":"An Australian Government service providing a single entry-point to aged care.","My Health Record":"A national digital health record system containing information about individuals\u2019 health care administered by the Australian Digital Health Agency.","National Aged Care Advocacy Program":"An Australian Department of Health initiative that provides free and confidential advocacy support to older people and their carers.","National Aged Care Mandatory Quality Indicator Program":"A program that collects certain quality indicator data from residential aged care services.","National Health Reform Agreement":"An agreement between the Australian Government and all State and Territory Governments under which the Australian Government contributes funds to State and Territories for public hospital services.","National Prioritisation System for Home Care Packages":"A process used by the Australian Government to prioritise and allocate Home Care Packages to people who have been assessed eligible for a package.","National Safety and Quality Health Service Standards":"The standards established by the Australian Commission on Safety and Quality in Health Care that apply to all health service providers in Australia, designed to protect the public from harm and improve the quality of service provision.","NDIS":"A national scheme established by the National Disability Insurance Scheme Act 2013 (Cth) that provides support to eligible people with intellectual, physical, sensory, cognitive and psychosocial disability.","partially supported residents":"Residents of aged care facilities whose income and assets are assessed under the means test as high enough to require them to pay for some of their accommodation costs, but not their care costs","personal care worker":"An occupational title assigned to people who provide care to older people, people with disability and health care patients in a range of settings, including private homes, hospitals and residential aged care facilities.","Primary Health Network":"An administrative health region established to deliver access to primary care services and coordinate with local hospitals to improve the overall operational efficiency of the network","Quality Review":"A process of reviewing the quality of home care services, Commonwealth Home Support Programme services and flexible care services against the Aged Care Quality Standards.","Refundable Accommodation Contribution":"A method of payment for residential aged care accommodation that does not accrue daily and is paid as a lump sum.","Refundable Accommodation Deposit":"A method of payment for residential aged care accommodation that does not accrue daily and is paid as a lump sum.","Regional Assessment Service":"An assessment service which assesses people seeking entry-level support at home provided under the Commonwealth Home Support Programme.","reportable assault":"Under the compulsory reporting scheme approved providers of residential care must notify the police and the Aged Care Quality and Safety Commission of reportable assaults","reportable incident":"National Disability Insurance Scheme providers must notify the NDIS Commission of all reportable incidents including the death, serious injury, abuse or neglect, of a person with disability.","residential aged care":"An Australian Government-funded and regulated service under the Aged Care Act 1997 (Cth) that provides accommodation and aged care to people requiring ongoing health and nursing care.","respite care":"Short-term support and care services for older people and their carers. The services can be provided in the home, in cottages, in residential facilities, or in purpose-built facilities.","Review Audit":"An onsite assessment of the quality of care and services provided to people receiving aged care by an accredited service, conducted by the Aged Care Quality and Safety Commissioner.","Serious Incident Response Scheme":"An Australian Government scheme intended to commence in 2021 for the reporting of abuse and neglect in residential aged care.","Short-term Restorative Care Program":"A flexible care service program that provides care and services to a person for up to eight weeks to help improve their physical functioning, wellbeing and independence.","site audit":"An unannounced comprehensive performance assessment against the Quality Standards undertaken for the purpose of informing a decision whether to re-accredit a residential aged care service.","Specialist Disability Accommodation":"Accommodation for people with disability, generally with extreme functional impairment or high care needs, funded through a separate component\r\nof the National Disability Insurance Scheme","Transition Care Program":"A short-term aged care program to support older people recover after  a hospital stay.","Veterans\u2019 Supplement":"A supplement payable to aged care providers who care for veterans with service-related mental health conditions.","Viability Supplement":"An additional payment the Australian Government makes to eligible aged care providers to assist with the additional cost of providing services in remote and some regional areas and to particular disadvantaged groups."`;
